// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.qualification__select[data-v-9345620a] {\n  margin-top: 15px;\n}\n.qualification__processing[data-v-9345620a] {\n  margin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
